export default function useActionExperience (getExperienceTiers, getExperienceStations, editBookingStationTime, stationAction, tierAction) {
  function experienceAction (experience, bookingStationTimeId, booking = null) {
    if (booking !== null) {
      const stations = getExperienceStations(experience.id);
      for (let index = 0; index < stations.length; index++) {
        const station = stations[index];
        const alreadyBooked = booking.bookingStationTimes.find(bookingStationTime => {
          return bookingStationTime.id !== bookingStationTimeId && !bookingStationTime._removed && bookingStationTime.station.id === station.id;
        });

        if (!alreadyBooked) {
          editBookingStationTime(bookingStationTimeId, 'experience', { id: experience.id });
          stationAction(getExperienceStations(experience.id)[index], bookingStationTimeId);
          tierAction(getExperienceTiers(experience.id)[0], bookingStationTimeId);
          return;
        }
      }

      /* none found, display a little flash informing the user */
      this.$store.commit('setFlash', {
        type: 'error',
        message: this.$t('The selected experience has no free stations'),
      });
    } else {
      editBookingStationTime(bookingStationTimeId, 'experience', { id: experience.id });
      stationAction(getExperienceStations(experience.id)[0], bookingStationTimeId);
      tierAction(getExperienceTiers(experience.id)[0], bookingStationTimeId);
    }
  }

  return {
    experienceAction,
  };
}
